(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nc-model-pills"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('nc-model-pills')) return;

    class NcModelPills extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ncmp-track]');
        this.prev = this.querySelector('[data-ncmp-prev]');
        this.next = this.querySelector('[data-ncmp-next]');
        this.thumb = this.querySelector('[data-ncmp-thumb]');
        this.param = this.dataset.param;

        this.track.addEventListener('click', this.onPick.bind(this));
        this.track.addEventListener('scroll', this.paintScroll.bind(this), { passive: true });
        this.prev.addEventListener('click', () => this.page(-1));
        this.next.addEventListener('click', () => this.page(1));
        window.addEventListener('resize', this.paintScroll.bind(this));

        // the filter bar swaps its "Modelo" group after every apply: re-read it
        var bar = document.querySelector('nc-filter-bar');
        if (bar) new MutationObserver(this.sync.bind(this)).observe(bar, { childList: true, subtree: true });

        this.revealActive();
        this.paintScroll();
        this.nudge();
      }

      inputs() {
        return Array.prototype.slice.call(document.querySelectorAll('nc-filter-bar input[name="' + this.param + '"]'));
      }

      onPick(e) {
        var pill = e.target.closest('[data-ncmp-value]');
        if (!pill) return;
        var value = pill.dataset.ncmpValue;
        var already = pill.classList.contains('ncmp__pill--on');
        var inputs = this.inputs();
        if (!inputs.length) {
          // no filter bar on the page: fall back to a plain URL change
          var url = new URL(window.location.href);
          url.searchParams.delete(this.param);
          url.searchParams.delete('page');
          if (value && !already) url.searchParams.append(this.param, value);
          window.location.href = url.href;
          return;
        }
        var target = value && !already ? value : null;
        inputs.forEach(function (i) { i.checked = target !== null && i.value === target; });
        this.paintActive(target);
        inputs[0].dispatchEvent(new Event('change', { bubbles: true }));
      }

      paintActive(value) {
        this.querySelectorAll('[data-ncmp-value]').forEach(function (p) {
          var on = value ? p.dataset.ncmpValue === value : p.dataset.ncmpValue === '';
          p.classList.toggle('ncmp__pill--on', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      // after an apply: active pill + live counts (other filters may lower them)
      sync() {
        var inputs = this.inputs();
        if (!inputs.length) return;
        var checked = inputs.filter(function (i) { return i.checked; });
        this.paintActive(checked.length === 1 ? checked[0].value : null);
        var counts = {};
        inputs.forEach(function (i) {
          var n = i.closest('label') && i.closest('label').querySelector('.ncfb__count');
          if (n) counts[i.value] = parseInt(n.textContent, 10);
        });
        this.querySelectorAll('[data-ncmp-value]').forEach(function (p) {
          var v = p.dataset.ncmpValue;
          if (!v || !(v in counts)) return;
          var n = counts[v];
          var el = p.querySelector('[data-ncmp-n]');
          if (el && el.textContent !== String(n)) el.textContent = n;
          p.classList.toggle('ncmp__pill--zero', n === 0 && !p.classList.contains('ncmp__pill--on'));
        });
        this.paintScroll();
      }

      page(dir) {
        var t = this.track;
        t.scrollBy({ left: dir * Math.max(160, t.clientWidth * 0.7), behavior: this.motion() ? 'smooth' : 'auto' });
      }

      motion() {
        return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      paintScroll() {
        var t = this.track;
        var max = t.scrollWidth - t.clientWidth;
        var scrolls = max > 4;
        var canPrev = scrolls && t.scrollLeft > 4;
        var canNext = scrolls && t.scrollLeft < max - 4;
        this.classList.toggle('ncmp--scrolls', scrolls);
        this.classList.toggle('ncmp--can-prev', canPrev);
        this.classList.toggle('ncmp--can-next', canNext);
        this.prev.hidden = !canPrev;
        this.next.hidden = !canNext;
        if (scrolls && this.thumb) {
          var w = Math.max(20, (t.clientWidth / t.scrollWidth) * 100);
          this.thumb.style.width = w + '%';
          this.thumb.style.left = (t.scrollLeft / max) * (100 - w) + '%';
        }
      }

      revealActive() {
        var on = this.querySelector('.ncmp__pill--on[data-ncmp-value]:not([data-ncmp-value=""])');
        if (on && on.offsetLeft + on.offsetWidth > this.track.clientWidth) {
          this.track.scrollLeft = on.offsetLeft - 16;
        }
      }

      // one small slide left and back, once per visit, so the row reads as swipeable
      nudge() {
        var t = this.track;
        if (!this.motion() || t.scrollWidth - t.clientWidth < 24 || t.scrollLeft > 0) return;
        try {
          if (sessionStorage.getItem('ncmp-nudged')) return;
          sessionStorage.setItem('ncmp-nudged', '1');
        } catch (e) {}
        setTimeout(function () {
          if (t.scrollLeft > 0) return;
          t.scrollTo({ left: 48, behavior: 'smooth' });
          setTimeout(function () { t.scrollTo({ left: 0, behavior: 'smooth' }); }, 550);
        }, 700);
      }
    }

    customElements.define('nc-model-pills', NcModelPills);
  })();
  } catch(e) { console.error(e); }
})();

})();
